import { apiSpiderMapBaseURL, apiFilesBaseURL } from '../../authentication/Global';
import { authenticationCentral } from '../../authentication/Authentication';
import { API, HTTPMethod, ContentType } from '../APICentral';

const settingsApiRoutes = {
    list: apiSpiderMapBaseURL + "settings/",
    stopImage: apiFilesBaseURL + "links/settings/stop-image/",
};

export class SettingsAPI {
    static listStops() {
        const url = `${settingsApiRoutes.list}`;

        return API.authenticatedRequest({
            url: url,
            method: HTTPMethod.GET,
            contentType: ContentType.JSON,
            token: authenticationCentral.accessToken
        });
    }

    static getStopImageLink(stopCode) {
        const url = new URL(stopCode, settingsApiRoutes.stopImage);

        return API.authenticatedRequest({
            url: url,
            method: HTTPMethod.GET,
            contentType: ContentType.JSON,
            token: authenticationCentral.accessToken
        });
    }
}



// WEBPACK FOOTER //
// ./src/api/spidermap/SettingsAPI.js